import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector } from "react-redux";
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy';
import applyFormat from '../functions/applyFormat';
import validateInputArray from '../functions/validateInputArray'; 
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation'; 
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditConsortiumRebateSetup = () => {
    // get page context from parent
    const {
        editConsortiumRebateSetupModal, 
        setEditConsortiumRebateSetupModal, 
        editConsortiumRebateSetupRow, 
        snackbarAlert, 
        getRefreshData, 
        rebateSetupInputConfig, 
        rebateSetupInputLists, 
        rebateInputTypeId, 
    } = useContext(PageContext); 
    // get HTTP context from parent
    const {
        PUT, 
    } = useContext(HttpContext); 
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    // initialize state 
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [statusChange, setStatusChange] = useState(false); 
    const [error, setError] = useState([{}]);

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!statusChange) {
                let requestValues = [{...values}]; 
                let dynamicArgs = {
                    incentiverate: {
                        rateTypeId: rebateInputTypeId,
                    } 
                }
                // validate input
                let checkError = validateInputArray(
                    requestValues, 
                    rebateSetupInputConfig,
                    dynamicValidation,
                    rebateSetupInputLists, 
                    snackbarAlert,  
                    error, 
                    setError, 
                    dynamicTransformation, 
                    dynamicArgs,
                ); 
                // exit request if error 
                if (checkError) {
                    reject(); 
                    return; 
                }
                // get oldValues to attach to request 
                let temp = {...editConsortiumRebateSetupRow}
                let oldValues = applyFormat(temp, rebateSetupInputConfig, rebateSetupInputLists, rebateInputTypeId); 
                oldValues = dynamicTransformation(oldValues, rebateSetupInputConfig, dynamicArgs); 
                // use POST function to make request 
                PUT('/consortium/rebateSetups', {
                    consortiumid: consortiumId, 
                    ...requestValues[0], 
                    oldValues: oldValues, 
                }).then(res => {
                    console.log(res); 
                    // default values 
                    let temp = {
                        ...values, 
                    }
                    setValues(values => values = temp); 
                    // set statusChange to false
                    setStatusChange(statusChange => statusChange = false); 
                    // show snackbar on success
                    snackbarAlert(true, 'Successfully edited rebate setup.', 'success'); 
                    // hide modal
                    setEditConsortiumRebateSetupModal(editConsortiumRebateSetupModal => editConsortiumRebateSetupModal = false); 
                    // refresh data 
                    return getRefreshData(); 
                }).then(res => {
                    // reject on success
                    resolve(res); 
                }).catch(err => {
                    console.log(err); 
                    // show snackbar on failure
                    snackbarAlert(true, 'Error editing rebate setup.', 'error'); 
                    // reject on error
                    reject(err); 
                }); 
            }
            else {  
                // validate status input 
                if (!rebateSetupInputLists['active'].includes(values['active'])){
                    // show snackbar on failure
                    snackbarAlert(true, 'Invalid status input.', 'error'); 
                    reject(); 
                    return; 
                }
                // use PUT function to make request 
                PUT('/consortium/rebateSetupStatus', {
                    active: values['active']['id'], 
                    incentivesetupid: values['incentivesetupid'], 
                    consortiumid: consortiumId
                }).then(res => {
                    console.log(res); 
                    // default values 
                    let temp = {
                        ...values, 
                    }
                    setValues(values => values = temp); 
                    // set statusChange to false
                    setStatusChange(statusChange => statusChange = false); 
                    // show snackbar on success
                    snackbarAlert(true, 'Successfully edited rebate setup.', 'success'); 
                    // hide modal
                    setEditConsortiumRebateSetupModal(editConsortiumRebateSetupModal => editConsortiumRebateSetupModal = false); 
                    // refresh data 
                    return getRefreshData(); 
                }).then(res => {
                    // reject on success
                    resolve(res); 
                }).catch(err => {
                    console.log(err); 
                    // show snackbar on failure
                    snackbarAlert(true, 'Error editing rebate setup.', 'error'); 
                    // reject on error
                    reject(err); 
                }); 
            }
        }); 
    }

    // onChangeFunction 
    const onChange = () => {
        // determine if status has changed 
        if (values['active']['id'] != editConsortiumRebateSetupRow['active']) {
            setStatusChange(statusChange => statusChange = true); 
            // add ids to lookup values 
            let temp = {
                ...editConsortiumRebateSetupRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, rebateSetupInputConfig, rebateSetupInputLists, rebateInputTypeId); 
        }
        else {
            setStatusChange(statusChange => statusChange = false); 
        }
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (rebateSetupInputConfig){
            setConfig(config => config = rebateSetupInputConfig); 
        }
    }, [rebateSetupInputConfig]); 

    // useEffect to run on editConsortiumRebateSetupRow change
    useEffect(() => {
        if (editConsortiumRebateSetupRow) {
            // add ids to lookup values 
            let temp = {
                ...editConsortiumRebateSetupRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, rebateSetupInputConfig, rebateSetupInputLists, rebateInputTypeId); 
            // set status change to false
            setStatusChange(statusChange => statusChange = false); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editConsortiumRebateSetupRow]); 

    
    return(
        <> 
        <CCOffcanvas
                title={`Edit Consortium Rebate Setup ${editConsortiumRebateSetupRow['incentivesetupid']}`}
                show={editConsortiumRebateSetupModal}
                onCanvasClose={() => setEditConsortiumRebateSetupModal(editConsortiumRebateSetupModal => editConsortiumRebateSetupModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-30"
            >   
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) => 
                            statusChange && el['columnid'] != 'active' ? 
                            <></>
                            : <>
                                <div>
                                    <DynamicPageInput data={values} setData={setValues} config={el} args={rebateSetupInputLists} width={'100%'} topAlignTypography={true} onChangeFunction={onChange} />
                                </div>
                            </>
                        )}
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setEditConsortiumRebateSetupModal(editConsortiumRebateSetupModal => editConsortiumRebateSetupModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditConsortiumRebateSetup; 